<template>
    <v-dialog v-model="dialogOpen" max-width="500px">
        <v-card>
            <toolbar-page title="Set new trial expiration date" disable-icon>
                <template slot="buttons">

                    <v-tooltip top color="primary" v-if="trialActive">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" icon v-on="on" @click="makePaying">
                                <v-icon>mdi-currency-usd</v-icon>
                            </v-btn>
                        </template>
                        <span>Remove trial and make this tenant a paying customer!</span>
                    </v-tooltip>

                    <v-tooltip top color="primary">
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" @click="dialogOpen=false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Close</span>
                    </v-tooltip>
                </template>

            </toolbar-page>

            <v-alert class="body-2" v-if="!trialActive" type="warning">
                This is a paying customer! There is a very few reasons to go back to trial.
                Sure you know what you are going?
            </v-alert>

            <v-date-picker
                    v-model="date"
                    color="primary"
                    full-width
                    landscape
                    :min="minDate"
                    :max="maxDate"
                    @change="dateChanged"
            ></v-date-picker>
        </v-card>
    </v-dialog>
</template>

<script>

    import ToolbarPage from '../../../components/UI/ToolbarPage';
    import moment from 'moment';

    export default {

        components: {
            ToolbarPage
        },

        props: {
            value: {
                type: Boolean,
                default: false,
                required: true
            },

            tenant: {
                type: Object,
                required: false,
                default: () => ({
                    updated_at: null,
                    created_at: null,
                    uuid: null,
                    fqdn: null,
                    trial_expires_on: null,
                })
            }
        },

        data() {
            return {
                date: null,
            }
        },

        watch: {
            tenant(tenant) {
                this.date = tenant.trial_expires_on;
            },
            value(bool) {
                if (bool) this.date = this.tenant.trial_expires_on;
            }
        },

        computed: {
            trialActive() {
                if (this.tenant.trial_expires_on !== null) {
                    return true;
                }
            },
            minDate() {
                return moment().add(7, 'days').format('YYYY-MM-DD');
            },
            maxDate() {
                return moment().add(90, 'days').format('YYYY-MM-DD');
            },
            dialogOpen: {
                get() {
                    return this.value;
                },
                set() {
                    this.closeDialog();
                }
            }
        },

        methods: {
            closeDialog() {
                this.$emit('input', false);
            },

            dateChanged(date) {
                let tenant = Object.assign({}, this.tenant);
                tenant.trial_expires_on = date;
                this.$emit('change', tenant);
                this.closeDialog();
            },

            makePaying() {
                let tenant = Object.assign({}, this.tenant);
                tenant.trial_expires_on = null;
                this.$emit('change', tenant);
                this.closeDialog();
            }
        }
    }
</script>
